import { isNodeEnv } from '@sentry/utils';

function isBrowser() {
  // eslint-disable-next-line no-restricted-globals
  return typeof window !== 'undefined' && !isNodeEnv();
}

export { isBrowser };